<template>
    <el-dialog
        class="edit-remark"
        :visible.sync="editVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="500px"
        title="Edit Remark"
        :lock-scroll="false"
        :modal-append-to-body="false"
        append-to-body
    >
        <div class="container">
            <el-form
                ref="editForm"
                :model="editForm"
                :rules="rules"
                label-width="80px"
            >
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="Shop" prop="shop_id" size="small">
                            <el-select
                                v-model="editForm.shop_id"
                                size="small"
                                clearable
                                filterable
                                placeholder="Placeholder Shop"
                            >
                                <el-option
                                    v-for="item in shopList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="Customer" prop="user_id" size="small">
                            <el-select
                                v-model="editForm.user_name"
                                placeholder="Please input user"
                                filterable
                                clearable
                                :filter-method="userSelect"
                                :remote="true"
                                @change="userChange"
                            >
                                <el-option
                                    v-for="item in userList"
                                    :key="item.id"
                                    :label="item.username"
                                    :value="item.id"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="Desc" prop="remark" size="small">
                            <el-input
                                type="textarea"
                                v-model="editForm.remark"
                                placeholder="Please input remark"
                                :autosize="{ minRows: 4, maxRows: 8 }"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" type="primary" @click="save"
                >Save</el-button
            >
            <el-button size="small" @click="editVisible = false"
                >Close</el-button
            >
        </span>
    </el-dialog>
</template>

<script>
import { cmofferApi } from "@/http/cmofferApi.js";
export default {
    data() {
        return {
            editForm: {
                shop_id: "",
                user_id: "",
                user_name: "",
                remark: "",
            },
            rules: {
                name: [
                    {
                        required: true,
                        message: "Please input name",
                    },
                ],
                value: [
                    {
                        required: true,
                        message: "Please input ioss",
                    },
                ],
                time: [
                    {
                        required: true,
                        message: "Please select time",
                    },
                ],
            },
            userList:[],
        };
    },
    methods: {
        userChange(val){            
            this.editForm.user_id = val;
        },
        closeDialog() {
            this.editForm = {
                shop_id: "",
                user_id: "",
                remark: "",
            };
            this.$refs["editForm"].clearValidate();
            this.$refs["editForm"].resetFields();
            this.$emit("update:editVisible", false);
        },
        save() {
            this.$refs["editForm"].validate((valid) => {
                if (valid) {
                    cmofferApi
                        .shopOrderRemark(
                            {
                                shop_id: this.editForm.shop_id,
                                user_id: this.editForm.user_id,
                                remark: this.editForm.remark,
                            },
                            "post",
                            this.tableItem.id
                        )
                        .then((res) => {
                            if (res) {
                                this.$message.success(
                                    this.$i18n.locale == "zh"
                                        ? "编辑成功"
                                        : "Success"
                                );
                                this.$parent[this.funcName] &&
                                    this.$parent[this.funcName]();
                                this.closeDialog();
                            }
                        });
                }
            });
        },
        shopOrderRemark() {
            cmofferApi
                .shopOrderRemark({}, "get", this.tableItem.id)
                .then((res) => {
                    if (res) {
                        this.editForm = {
                            shop_id: res.data.shop_id,
                            user_id: res.data.user_id,
                            user_name: res.data.user_name,
                            remark: res.data.remark,
                        };
                    }
                })
                .catch(() => {});
        },
        userSelect(val){
            cmofferApi.userSelect({keyword: val}, "get").then((res) => {
                if (res) {
                    this.userList = res.data;
                }
            });
        }
    },
    props: {
        editVisible: Boolean,
        tableItem: Object,
        funcName: String,
        shopList: () => Array,
    },
    watch: {
        editVisible(val) {
            if (val) {
                this.shopOrderRemark();
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.edit-remark {
    .container {
        .el-select--small {
            width: 100%;
        }
    }
}
</style>
